/* Kairos Kart marketplace components (kk-*): search suggestions, departments drawer,
   hero slider, product rails, deal countdown, quick add to cart, recently viewed.
   Every init is idempotent so sections re-rendered in the theme editor work again. */
(function () {
  'use strict';
  if (window.KKMarket) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
  var RV_KEY = 'kk_recently_viewed';
  var RV_MAX = 12;

  function money(amount, isCents) {
    var value = Number(amount);
    if (!isFinite(value)) return '';
    if (isCents) value = value / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: CURRENCY, maximumFractionDigits: value % 1 ? 2 : 0 }).format(value);
    } catch (e) {
      return value.toFixed(2);
    }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function once(el, key) {
    if (el.dataset[key] === '1') return false;
    el.dataset[key] = '1';
    return true;
  }
  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, ms);
    };
  }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(message, opts) {
    opts = opts || {};
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'kk-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('kk-toast--error', !!opts.error);
    toastEl.innerHTML = '<span>' + esc(message) + '</span>' +
      (opts.link ? '<a href="' + esc(opts.link.href) + '">' + esc(opts.link.label) + '</a>' : '');
    requestAnimationFrame(function () { toastEl.dataset.open = 'true'; });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.dataset.open = 'false'; }, 4000);
  }

  /* ---------- Quick add to cart ---------- */
  function refreshCartCount() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count || 0;
        document.querySelectorAll('cart-icon').forEach(function (icon) {
          if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(count);
        });
        document.querySelectorAll('[ref="cartBubbleCount"]').forEach(function (el) {
          el.textContent = count < 100 ? String(count) : '';
          el.classList.toggle('hidden', count === 0);
        });
        document.querySelectorAll('[ref="cartBubble"]').forEach(function (el) {
          el.classList.toggle('visually-hidden', count === 0);
        });
      })
      .catch(function () {});
  }
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.kk-add');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();
    var id = Number(btn.dataset.variantId);
    if (!id) return;
    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = btn.dataset.loadingLabel || 'Adding…';
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
          return data;
        });
      })
      .then(function () {
        btn.textContent = btn.dataset.addedLabel || 'Added ✓';
        toast(btn.dataset.toast || 'Added to your cart', { link: { href: ROOT + 'cart', label: btn.dataset.viewCartLabel || 'View cart' } });
        return refreshCartCount();
      })
      .catch(function (err) {
        btn.textContent = label;
        toast(err.message, { error: true });
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        setTimeout(function () { btn.textContent = label; }, 1800);
      });
  });

  /* ---------- Departments drawer ---------- */
  function initDrawer(root) {
    var openBtn = root.querySelector('[data-kk-drawer-open]');
    var drawer = root.querySelector('[data-kk-drawer]');
    if (!openBtn || !drawer || !once(openBtn, 'kkInit')) return;
    var lastFocus;
    function close() {
      drawer.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('kk-lock');
      if (lastFocus) lastFocus.focus();
    }
    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('kk-lock');
      var first = drawer.querySelector('[data-kk-drawer-close]');
      if (first) first.focus();
    }
    openBtn.addEventListener('click', open);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-kk-drawer-close]') || e.target.hasAttribute('data-kk-backdrop')) close();
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key !== 'Tab') return;
      var f = drawer.querySelectorAll('a, button, summary');
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  }

  /* ---------- Search suggestions (Shopify predictive search) ---------- */
  function initSearch(form) {
    if (!once(form, 'kkInit')) return;
    var input = form.querySelector('input[name="q"]');
    var box = form.querySelector('[data-kk-suggest]');
    if (!input || !box) return;
    var active = -1, controller;
    function items() { return box.querySelectorAll('.kk-suggest__item'); }
    function hide() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
    function highlight(i) {
      var list = items();
      list.forEach(function (el, n) { el.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      active = i;
    }
    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { hide(); return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { signal: controller ? controller.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          var allUrl = form.action + '?q=' + encodeURIComponent(q) + '&type=product';
          if (!products.length) {
            box.innerHTML = '<div class="kk-suggest__empty">' + esc(form.dataset.emptyLabel || 'No products found') + '</div>';
          } else {
            box.innerHTML = products.map(function (p, i) {
              var img = p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=96" alt="" loading="lazy">' : '<span class="kk-suggest__thumb"></span>';
              return '<a class="kk-suggest__item" role="option" id="kk-sg-' + i + '" aria-selected="false" href="' + esc(p.url) + '">' + img +
                '<span class="kk-suggest__text"><span>' + esc(p.title) + '</span>' +
                (p.price ? '<span class="kk-suggest__price">' + esc(money(p.price)) + '</span>' : '') + '</span></a>';
            }).join('') + '<a class="kk-suggest__all" href="' + esc(allUrl) + '">' + esc(form.dataset.allLabel || 'See all results') + ' →</a>';
          }
          box.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          active = -1;
        })
        .catch(function () {});
    }, 200);
    input.addEventListener('input', run);
    input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length > 1) { box.hidden = false; } });
    input.addEventListener('keydown', function (e) {
      var list = items();
      if (e.key === 'ArrowDown' && list.length) { e.preventDefault(); highlight(Math.min(active + 1, list.length - 1)); }
      else if (e.key === 'ArrowUp' && list.length) { e.preventDefault(); highlight(Math.max(active - 1, 0)); }
      else if (e.key === 'Enter' && active > -1 && list[active]) { e.preventDefault(); window.location.href = list[active].href; }
      else if (e.key === 'Escape') hide();
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
  }

  /* ---------- Horizontal rails (products, recently viewed) ---------- */
  function initRail(rail) {
    var track = rail.querySelector('[data-kk-track]');
    var prev = rail.querySelector('[data-kk-prev]');
    var next = rail.querySelector('[data-kk-next]');
    if (!track || !once(rail, 'kkInit')) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: reduceMotion ? 'auto' : 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', debounce(update, 60), { passive: true });
    window.addEventListener('resize', debounce(update, 150));
    update();
    rail._kkUpdate = update;
  }

  /* ---------- Hero slider ---------- */
  function initHero(hero) {
    var track = hero.querySelector('[data-kk-track]');
    if (!track || !once(hero, 'kkInit')) return;
    var slides = track.children;
    var dots = hero.querySelectorAll('[data-kk-dot]');
    var delay = Number(hero.dataset.autoplay || 0) * 1000;
    var index = 0, timer;
    function go(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function markCurrent() {
      var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      index = Math.max(0, Math.min(i, slides.length - 1));
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === index ? 'true' : 'false'); });
      Array.prototype.forEach.call(slides, function (s, n) { s.setAttribute('aria-hidden', n === index ? 'false' : 'true'); });
    }
    function play() { stop(); if (delay && !reduceMotion && slides.length > 1) timer = setInterval(function () { go(index + 1); }, delay); }
    function stop() { clearInterval(timer); }
    var prev = hero.querySelector('[data-kk-prev]');
    var next = hero.querySelector('[data-kk-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); play(); });
    if (next) next.addEventListener('click', function () { go(index + 1); play(); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); play(); }); });
    track.addEventListener('scroll', debounce(markCurrent, 80), { passive: true });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', play);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', play);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else play(); });
    markCurrent();
    play();
  }

  /* ---------- Deal countdown ---------- */
  function initCountdown(el) {
    if (!once(el, 'kkInit')) return;
    var end = Date.parse(el.dataset.kkCountdown);
    var section = el.closest('[data-kk-deal]');
    if (!isFinite(end)) { el.hidden = true; return; }
    var parts = { d: el.querySelector('[data-u="d"]'), h: el.querySelector('[data-u="h"]'), m: el.querySelector('[data-u="m"]'), s: el.querySelector('[data-u="s"]') };
    var pad = function (n) { return String(n).padStart(2, '0'); };
    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        clearInterval(t);
        el.hidden = true;
        var ended = section && section.querySelector('[data-kk-ended]');
        if (ended) ended.hidden = false;
        if (section && section.dataset.hideWhenEnded === 'true' && !window.Shopify?.designMode) section.hidden = true;
        return;
      }
      var s = Math.floor(left / 1000);
      if (parts.d) { parts.d.textContent = pad(Math.floor(s / 86400)); parts.d.parentElement.hidden = s < 86400; }
      parts.h.textContent = pad(Math.floor((s % 86400) / 3600));
      parts.m.textContent = pad(Math.floor((s % 3600) / 60));
      parts.s.textContent = pad(s % 60);
    }
    var t = setInterval(tick, 1000);
    tick();
  }

  /* ---------- Recently viewed ---------- */
  function readRV() {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]').filter(function (h) { return typeof h === 'string'; }); }
    catch (e) { return []; }
  }
  function recordRV(handle) {
    if (!handle) return;
    var list = readRV().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, RV_MAX))); } catch (e) {}
  }
  function cardHTML(p, labels) {
    var v = (p.variants || []).find(function (x) { return x.available; }) || (p.variants || [])[0] || {};
    var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=480' : '';
    var sale = p.compare_at_price && p.compare_at_price > p.price;
    var pct = sale ? Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) : 0;
    var single = (p.variants || []).length === 1;
    var action = !p.available
      ? '<span class="kk-soldout">' + esc(labels.soldOut) + '</span>'
      : single
        ? '<button type="button" class="kk-btn kk-add" data-variant-id="' + v.id + '">' + esc(labels.add) + '</button>'
        : '<a class="kk-btn kk-btn--ghost" href="' + esc(p.url) + '">' + esc(labels.options) + '</a>';
    return '<article class="kk-card">' +
      '<a class="kk-card__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
      (img ? '<img class="kk-card__img" src="' + esc(img) + '" alt="" loading="lazy" width="480" height="480">' : '') +
      (sale ? '<span class="kk-badge">-' + pct + '%</span>' : '') + '</a>' +
      '<div class="kk-card__body"><a class="kk-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<div class="kk-price"><span class="kk-price__now">' + esc(money(p.price, true)) + '</span>' +
      (sale ? '<s class="kk-price__was">' + esc(money(p.compare_at_price, true)) + '</s>' : '') + '</div>' +
      action + '</div></article>';
  }
  function initRecentlyViewed(section) {
    if (!once(section, 'kkInit')) return;
    var current = section.dataset.kkRecord;
    var list = readRV().filter(function (h) { return h !== current; }).slice(0, Number(section.dataset.limit || 10));
    if (current) recordRV(current);
    var track = section.querySelector('[data-kk-track]');
    if (!track || !list.length) return;
    var labels = { add: section.dataset.addLabel || 'Add to cart', options: section.dataset.optionsLabel || 'Choose options', soldOut: section.dataset.soldOutLabel || 'Out of stock' };
    Promise.all(list.map(function (h) {
      return fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var found = products.filter(Boolean);
      if (!found.length) return;
      track.innerHTML = found.map(function (p) { return cardHTML(p, labels); }).join('');
      section.hidden = false;
      var rail = section.querySelector('[data-kk-rail]');
      if (rail && rail._kkUpdate) rail._kkUpdate();
    });
  }

  /* ---------- Boot ---------- */
  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-kk-dept]').forEach(initDrawer);
    scope.querySelectorAll('[data-kk-search]').forEach(initSearch);
    scope.querySelectorAll('[data-kk-hero]').forEach(initHero);
    scope.querySelectorAll('[data-kk-rail]').forEach(initRail);
    scope.querySelectorAll('[data-kk-countdown]').forEach(initCountdown);
    scope.querySelectorAll('[data-kk-recent]').forEach(initRecentlyViewed);
  }
  window.KKMarket = { init: init, toast: toast, money: money };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
